import Store from './store'
import { observable, computed } from 'mobx'

export default class PaginatedStore extends Store {
  @observable pagination = {}

  @computed get prevPage() {
    const { current_page } = this.pagination
    const prev = current_page - 1
    return prev > 0 ? prev : null
  }

  @computed get nextPage() {
    const { total_pages, current_page } = this.pagination
    const next = current_page + 1
    return next <= total_pages ? next : null
  }

  get currentPage() {
    return this.pagination.current_page
  }
  get totalPages() {
    return this.pagination.total_pages
  }

  loadPage(page=1, query={}) {
    return this.connection.load(null, { ...query, page })
      .then(resp => resp.data)
      .then(({ results, meta }) => {
        this.records = results
        this.pagination = meta
      })
  }
}



// WEBPACK FOOTER //
// client/stores/paginated_store.js